import React from 'react';
import { Modal, Spin, Button } from 'antd';
import {
  LoadingOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { CLEAR_ERRORS } from '../../state/error/types';
import PropTypes from 'prop-types';

const spinnerIcon = <LoadingOutlined style={{ fontSize: 50 }} spin />;

/**
 * @param {modalVisible} boolean set if modal is visible
 * @param {title} string modal title
 * @param {okText} string Confirmation button text
 * @param {cancelText} string Cancel button text
 * @param {onCancel} function Cancel button function
 * @param {onOk} function Ok button function
 * @param {content} string Modal content
 * @param {buttonIcon} string Modal deploy button icon
 * @param {buttonOnClick} function Modal deploy button function
 * @param {buttonLabel} string Modal button text
 */

const ModalComponent = ({ ...props }) => {
  return (
    <React.Fragment>
      <Modal
        visible={props.modalVisible}
        title={props.title}
        okText={props.okText}
        cancelText={props.cancelText}
        onCancel={() => props.onCancel()}
        afterClose={() => props.clearErrors()}
        onOk={() => props.onOk()}
        okButtonProps={{ disabled: props.spinning }}
        cancelButtonProps={{ disabled: props.spinning }}
        bodyStyle={props.bodyStyle}
        width={props.width}
        centered={props.centered}
        footer={props.footer}
        maskClosable={props.maskClosable}
      >
        <Spin
          spinning={props.spinning}
          size="large"
          indicator={spinnerIcon}
        >
          {props.content}
        </Spin>
      </Modal>
      <Button icon={props.buttonIcon} size={props.buttonSize} type={props.type} onClick={() => props.buttonOnClick()}>
        {props.buttonLabel}
      </Button>
    </React.Fragment>
  );
};

ModalComponent.propTypes = {
  modalVisible: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  okText: PropTypes.string,
  cancelText: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
  onOk: PropTypes.func,
  spinning: PropTypes.bool.isRequired,
  bodyStyle: PropTypes.object,
  width: PropTypes.string,
  centered: PropTypes.bool,
  footer: PropTypes.string,
  maskClosable: PropTypes.bool,
  content: PropTypes.object.isRequired,
  buttonIcon: PropTypes.object,
  buttonSize: PropTypes.string,
  type: PropTypes.string,
  buttonOnClick: PropTypes.func,
  buttonLabel: PropTypes.string,
};

const action = (dispatch) => ({
  clearErrors: () => dispatch({ type: CLEAR_ERRORS }),
});

export default connect(null, action)(ModalComponent);